import {createSelector} from '@reduxjs/toolkit'

const businessContactDetailSelector = createSelector(
    [state => state.components,
    state => state.primaryAgencyApplication.application?.businessLicenceData],
    (components, appData) => {
        return Object.assign({}, 
            components.businessContactDetail, {
            mainBusinessContact : appData?.mainBusinessContact ?? {},
            complianceOfficer : appData?.complianceOfficer ?? {},
            responsibleAgent : appData?.responsibleAgent ?? {}
        })
    }
)

export const businessContactDetailSelect = state => ({
    businessContactDetail: businessContactDetailSelector(state)
})

export function populateBusinessContactDetailsForReview (businessContact){
    if(businessContact) {
        return {
            "First name" : businessContact.firstName,
            "Last name" : businessContact.lastName,
            "Phone number" : businessContact.phoneNumber,
            "Email address" : businessContact.emailAddress
        }
    }
    
    return {
        "First name" : "",
        "Last name" : "",
        "Phone number" : "",
        "Email address" : ""
    }
}
